import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { Card } from '../../components/UI/Card'
import FoodStoreActionBar from '../../components/FoodStore/FoodStoreActionBar'
import { useDispatch, useSelector } from 'react-redux'

export default function StoreNotifications() {
    const foodstore = useSelector(state => state.user_data?.user_stores.find(s => s?.default))

    // ui states
    const [loading, setLoading] = useState(true)
    
    const handleOnBulkRemove = () => {
        // const selectedStore = myFoodstore ?? sharedWithMeStore
        setLoading(true)
      }

    return (
        <div className="w-full px-2">
            <div className="bg-an_white w-full border border-an_green-dark rounded">
                <h5 className="flex bg-an_green-dark border p-2 text-an_white border-an_green-dark w-full rounded-t overflow-hidden">
                    <span>{foodstore?.name}</span>

                    <Link to={`/user-stores`} className="border border-an_white ml-auto rounded text-an_white p-1 text-xs">
                        manage
                    </Link>
                </h5>

                <div>
                    <FoodStoreActionBar foodstore={foodstore} itemsToManage={foodstore?.items} onRemove={handleOnBulkRemove} />
                </div>
            </div>
        </div>
    )
}